module.exports = __webpack_public_path__ + "static/media/gift-monthly.fceebda6.svg";